export function toggleSelection(selected: ReadonlySet<string>, id: string, checked?: boolean): Set<string> {
  const next = new Set(selected);
  const include = checked ?? !next.has(id);
  if (include) next.add(id); else next.delete(id);
  return next;
}

export function selectAll(selected: ReadonlySet<string>, ids: string[], checked: boolean): Set<string> {
  const next = new Set(selected);
  ids.forEach(id => checked ? next.add(id) : next.delete(id));
  return next;
}

export function retainAvailable(selected: ReadonlySet<string>, ids: string[]): Set<string> {
  const available = new Set(ids);
  return new Set([...selected].filter(id => available.has(id)));
}
